import React from "react";
import {observer} from "mobx-react";
import {SearchMaskComponent} from "../../components/search-mask/search-mask.component";
import {DROP_DOWN_POPPER_ANCHOR_ELEMENT_ID} from "../../components/drop-down/popper-drop-down.model";
import styled from "styled-components";
const HomePageBox = styled.div`
    background-color: ${props => props.theme.colors.darkContrast};
`

const DropDownPopperAnchorBox = styled.div`
    position: fixed;
    top: -1px; /*because on mobile when we show a drop down the user can see behind the top border of the SearchMaskTripTypeComponent*/
    left: 0;
    height: 1px;
    width: 100%;
`

export const HomePage: React.FC = observer(() => {

    const renderPopperAnchor = () => {
        return (
            <DropDownPopperAnchorBox id={DROP_DOWN_POPPER_ANCHOR_ELEMENT_ID}/>
        );
    }

    return (
        <HomePageBox>
            {renderPopperAnchor()}
            <SearchMaskComponent/>
        </HomePageBox>
    )
});
